import { Directive } from '@angular/core';
import { ClassDirective } from '@ngbracket/ngx-layout';

const selector = `[ngClass.gt-mv], [ngClass.lt-mv]`;
const inputs = ['ngClass.gt-mv', 'ngClass.lt-mv'];

/**
 * @deprecated to be removed because FlexLayout is obsolete - see migration-from-flex-layout.md for details
 */
@Directive({ selector, inputs })
export class MobileClassDirective extends ClassDirective {
  protected inputs = inputs;
}
